import api from '../api';

export async function createOvertime(overtimeData) {
  try {
    const response = await api.post('/over-time', overtimeData);
    return response.data;
  } catch (error) {
    console.error('Error creating overtime:', error);
    throw error;
  }
}

export async function getOvertimeByEmployeeId(employeeId) {
  try {
    const response = await api.get(`/over-time/employee/${employeeId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching overtime for employee:', error);
    throw error;
  }
}

export async function updateOvertime(id, overtimeData) {
  try {
    const response = await api.put(`/over-time/${id}`, overtimeData);
    return response.data;
  } catch (error) {
    console.error('Error updating overtime:', error);
    throw error;
  }
}

export async function deleteOvertime(id) {
  try {
    const response = await api.delete(`/over-time/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting overtime:', error);
    throw error;
  }
}
